var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgXlsx = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Flat",
  height: 512,
  viewBox: "0 0 512 512",
  width: 512,
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m392 488h-272a48 48 0 0 1 -48-48v-368a48 48 0 0 1 48-48h224l96 96v320a48 48 0 0 1 -48 48z",
  fill: "#cfd2fc"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m72 360h368a0 0 0 0 1 0 0v80a48 48 0 0 1 -48 48h-272a48 48 0 0 1 -48-48v-80a0 0 0 0 1 0 0z",
  fill: "#5153ff"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "m440 120h-48a48 48 0 0 1 -48-48v-48z",
  fill: "#8690fa"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "m136 144h240v144h-240z",
  fill: "#8690fa"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "m312 144h16v144h-16z",
  fill: "#fff"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "m248 144h16v144h-16z",
  fill: "#fff"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "m136 112h64v176h-64z",
  fill: "#5153ff"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "m240 448h-24v-56a8 8 0 0 0 -16 0v64a8 8 0 0 0 8 8h32a8 8 0 0 0 0-16z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m179.578 384.845a8 8 0 0 0 -10.733 3.577l-8.845 17.689-8.845-17.689a8 8 0 0 0 -14.31 7.156l14.211 28.422-14.211 28.422a8 8 0 1 0 14.31 7.156l8.845-17.689 8.845 17.689a8 8 0 1 0 14.31-7.156l-14.211-28.422 14.211-28.422a8 8 0 0 0 -3.577-10.733z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m371.578 384.845a8 8 0 0 0 -10.733 3.577l-8.845 17.689-8.845-17.689a8 8 0 0 0 -14.31 7.156l14.211 28.422-14.211 28.422a8 8 0 1 0 14.31 7.156l8.845-17.689 8.845 17.689a8 8 0 1 0 14.31-7.156l-14.211-28.422 14.211-28.422a8 8 0 0 0 -3.577-10.733z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m288 400h16a8 8 0 0 0 0-16h-16a24 24 0 0 0 0 48 8 8 0 0 1 0 16h-16a8 8 0 0 0 0 16h16a24 24 0 0 0 0-48 8 8 0 0 1 0-16z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m184 112h16v176h-16z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m136 144h240v16h-240z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m136 240h240v16h-240z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m136 192h240v16h-240z"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgXlsx);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/xlsx.49e3d0482a5222c976ffcc62282aac7f.svg";